import { createContext, useState } from 'react';

export const GlobalContext = createContext();

const initialState = {
  siteFilter: 1,
  tags: [],
  documents: [],
  documentsAll: [],
  isSmallHeader: true,
  isVisibleHeader: true,
  historyModal: {
    isVisible: false,
    norma: {},
    TipoDoc: 1
  },
  searchTerm: '',
  user: {
    isAuthenticated: false,
    login: '',
    token: '',
  },
  pagination: {
    limit: 5,
    minPage: 1,
    maxButtons: 5,
  },
  pdfModal: {
    isVisible: false,
    url: '',
    title: '',
  },
  classificationModal: {
    isVisible: false,
    callback: '',
  },
  validationModal: {
    isVisible: false,
    title: '',
    text: '',
    status: '',
    callback: null,
  },
  treeModal: {
    isVisible: false,
    documents: [],
  },
  relatedDocumentsModal: {
    isVisible: false,
    selectedDocuments: [],
    files: [],
  },
  loading: false,
  responseMsg: {
    isVisible: false,
    error: true,
    msg: '',
  },
  quantidadeModal: false
};

export const AppContext = ({ children }) => {
  const [pagination, setPagination] = useState(initialState.pagination);
  const [searchTerm, setSearchTerm] = useState(initialState.searchTerm);
  const [documents, setDocuments] = useState(initialState.documents);
  const [documentsAll, setDocumentsAll] = useState(initialState.documents);
  const [tags, setTags] = useState(initialState.tags);
  const [isSmallHeader, setIsSmallHeader] = useState(initialState.isSmallHeader);
  const [isVisibleHeader, setIsVisibleHeader] = useState(initialState.isVisibleHeader);
  const [historyModal, setHistoryModal] = useState(initialState.historyModal);
  const [pdfModal, setPdfModal] = useState(initialState.pdfModal);
  const [classificationModal, setClassificationModal] = useState(initialState.classificationModal);
  const [validationModal, setValidationModal] = useState(initialState.validationModal);
  const [loading, setLoading] = useState(initialState.loading);
  const [responseMsg, setResponseMsg] = useState(initialState.responseMsg);
  const [user, setUser] = useState(initialState.user);
  const [treeModal, setTreeModal] = useState(initialState.treeModal);
  const [quantidadeModal, setQuantidadeModal] = useState(initialState.quantidadeModal);
  const [relatedDocumentsModal, setRelatedDocumentsModal] = useState(initialState.relatedDocumentsModal);
  const [siteFilter, setSiteFilter] = useState(window?.SABESP_API_CONFIG?.Tipo || initialState.siteFilter);

  return (
      <GlobalContext.Provider
          value={{
            siteFilter,
            setSiteFilter,
            pagination,
            setPagination,
            searchTerm,
            setSearchTerm,
            documents,
            setDocuments,
            documentsAll,
            setDocumentsAll,
            isSmallHeader,
            setIsSmallHeader,
            isVisibleHeader,
            setIsVisibleHeader,
            historyModal,
            setHistoryModal,
            user,
            setUser,
            pdfModal,
            setPdfModal,
            classificationModal,
            setClassificationModal,
            validationModal,
            setValidationModal,
            treeModal,
            setTreeModal,
            relatedDocumentsModal,
            setRelatedDocumentsModal,
            loading,
            setLoading,
            responseMsg,
            setResponseMsg,
            tags,
            setTags,
            quantidadeModal,
            setQuantidadeModal,
          }}
      >
        {children}
      </GlobalContext.Provider>
  );
};
